<template>
    <div class="container mt-10">
        <p>&nbsp;</p>
            <h4 class="back">

            </h4>
            <div class="profile-container mt-10">
                <div class="profile-image">
                    <span v-if="escort_data.profilepic == null" class="select-profile">
                        <img src="../assets/no_image.png" class="large-profile-pic" alt="" width="140px" height="140px" style="border-radius: 50%;">
                    </span>
                    <span v-else class="select-profile">
                        <img :src="escort_data.profilepic" 
                        class="large-profile-pic" alt="" 
                        width="140px" height="140px" 
                        style="border-radius: 50%; cursor: pointer;"
                        @click="selectedImage = escort_data.profilepic; showImageDialog = true"
                        >

                        <div class="likes-followers mt-2">
                            <!-- <h4 class="badge badge-info">{{ countLikes }} likes</h4> &nbsp; -->
                            <h4 class="badge badge-primary">{{ countFollowers }} followers</h4>
                        </div>
                    </span>

                    <div class="profile-info">
                        <h3>{{ escort_data.user_name }} ({{ escort_data.age }})
                            <span v-if="escort_data.activation_paid == 1" class="verified-icon" title="Verified">
                                <i class="fa fa-check-circle text-success"></i>
                            </span>
                        </h3>
                        <p>{{ escort_data.location }} {{ escort_data.state }} | {{ escort_data.gender }} | <i class="fa fa-phone"></i>
                            <span v-if="escort_data.activation_paid == 1 || new Date(escort_data.trial_ends_at) > new Date()">
                                {{ escort_data.phone_number }}
                            </span>
                            <span v-else>
                                ***********
                            </span>
                        </p>
                        <hr class="mobile-line">
                        <p>{{ escort_data.bio }} </p>
                      
                    </div>
                </div>

                <div class="profile-edit-button">
               
                <!-- Conditionally render chat button -->
                <button
                    v-if="escort_data.activation_paid == 1 || new Date(escort_data.trial_ends_at) > new Date()"
                    class="btn-chat"
                      @click="handleChat"
                >
                    <i class="fa fa-comment"></i>&nbsp; Chat
                </button>

                <!-- Disabled version -->
                <span
                    v-else
                    class="btn-chat disabled-chat"
                    title="Chat"
                    style="cursor: not-allowed; opacity: 0.5;"
                >
                    <i class="fa fa-comment"></i>&nbsp; Chat
                </span>
                </div>
            </div>

            <div class="bio-tab mt-3">
                <!-- Nav Tabs -->
                <ul class="nav nav-tabs mb-3" role="tablist">
                    <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === tab.name }"
                        @click="activeTab = tab.name"
                        href="#"
                    >
                        {{ tab.label }}
                    </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content p-0 border rounded bg-light">
                    <div v-if="activeTab === 'tour'">
                        <h5><strong><i class="fas fa-route"></i> Tour </strong></h5>
                        

                   
                        <div class="col-md-4 mb-3" v-for="(tour, index) in escort_tour" :key="index">
                            <div class="p-3 border rounded shadow-sm h-100 bg-white position-relative">
                            <!-- Travel Info -->
                            <div class="d-flex justify-content-between mb-2">
                                <span class="fw-bold text-primary">
                                <i class="fa fa-map-marker-alt me-1"></i> Location
                                </span>
                                <span class="fw-bold text-danger">
                                <i class="fa fa-arrow-right me-1"></i> {{ tour.to_city }}
                                </span>
                            </div>

                            <!-- Travel Date -->
                            <div class="mb-2 small text-muted">
                                <i class="fa fa-calendar-alt me-1"></i> Tour Date:
                                <span class="fw-semibold text-dark">{{ new Date(tour.travel_date).toDateString() }}</span>
                            </div>
                            <!-- Travel Date -->
                            <div class="mb-2 small text-muted">
                                <i class="fa fa-phone-alt me-1"></i> Phone Number:
                                <span class="fw-semibold text-dark">{{ escort_data.phone_number}}</span>
                            </div>
                            </div>
                        </div>
                    

                    </div>
                </div>
            </div>

            <div v-if="splashScreen">
                <transition name="modal" >
                    <div class="modal-mask">
                        <div class="modal-wrapper col-md-4" style="margin:auto">
                            <!-- <div class="modal-dialog modal-xl"> -->
                                <div class="profile-view2">
                                    <hr style="color:#3E3D3D; margin-top:-20px">
                                    <span class="profile-bio2">
                                        <p style="font-size:x-large">
                                            <i class="fas fa-spinner"></i> Processing...
                                        </p>
                                    </span>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                </transition>
            </div> 

            <v-dialog v-model="showImageDialog" max-width="800px">
            <v-card>
                <v-img :src="selectedImage" aspect-ratio="1.5" contain></v-img>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="pink darken-1" @click="showImageDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>

        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    
</template>
<script>
import swal from 'sweetalert2';
import PageLoader from '../components/PageLoader.vue'

export default {

    components: {
        PageLoader
    },
    
    data() {
    return {
        isLoading: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        escort_tour: [],

        escort_data: '',
        userid: '',
        activeTab: 'tour',
        tabs: [
            { name: 'tour', label: 'Tour Details' }
        ],
        preferences: [],
        rates: [],
        user_id: '',
        user_role: '',
        countLikes: 0,
        countFollowers: 0,
        image_likes: [],
        escort_video: [],
        likeCountsMap: {}, // holds like counts per image

        };
    },

    beforeMount(){
        this.userid =  this.$route.params.escortid; 
    },

    mounted(){

        this.listMyProfile(this.userid);

        this.fetchRates(this.userid)
        this.getLikes(this.userid)
        this.getFollowers(this.userid)
        this.user_id = localStorage.getItem("userid");
        this.user_role = localStorage.getItem("role");
        if (this.user_role ==="guest") {
          this.getUserEscortLikes(this.userid)
        }
      
    },

methods: {

    isImageLiked(image) {
    const match = this.image_likes.some(liked => liked.image === image);
    if (match) {
        //console.log("Image is liked:", image);
    }
    return match;
    },

    async listEscortTour(escortid){
         try{

        const response = await this.$http.post('/list-escort-tours',{ escortid: escortid} )
        this.escort_tour = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async fetchLikeCount(image) {
    try {
      const response = await this.$http.get(`/image-likes/${encodeURIComponent(image)}`);
      this.$set(this.likeCountsMap, image, response.data.data.length);
    } catch (err) {
      console.error(err);
      console.log(err.response?.data?.message || 'Server error occurred.')
      // swal.fire({
      //   icon: 'error',
      //   title: 'Error',
      //   text: err.response?.data?.message || 'Server error occurred.',
      //   width: 400
      // });
    }
  },

    isVideoLiked(video) {
    const match = this.image_likes.some(liked => liked.image === video);
    if (match) {
        //console.log("Image is liked:", image);
    }
    return match;
    },

    formatPrice(value) {
      return Number(value).toLocaleString('en-NG', {
        minimumFractionDigits: 0
      });
    },

    backProfile() {
        this.profile = true,
        this.edit_profile = false
    },

    async listMyProfile(userid){
         try{
            this.isLoading = true
            const response = await this.$http.post('/list-escort-info',{ user_id: userid} )
            this.escort_data = response.data.data;
            this.escortid = this.escort_data.id

            this.listEscortTour(this.escortid)
            this.listEscortPreferences(this.escort_data.escortid)
            this.listEscortVideos(this.escort_data.escortid)
            
            this.isLoading = false
        
            }catch (err) {
                console.log(err);
            }
    },

    async listEscortVideos(userid){
         try{

            const response = await this.$http.post('/list-escort-videos-byuser',{ user_id: userid} )
            this.escort_video = response.data.data;

            }catch (err) {
                console.log(err);
            }
    },

    async listEscortPreferences(escortid){
         try{
            const response = await this.$http.post('/list-escort-preferences',{ escort_id: escortid} )
            
            const first = response.data.data[0];

            if (!first || first === '') {
              this.preferences = [{ username: this.escort_data.user_name }];
            } else {
              this.preferences = first;
            }

            }catch (err) {
                console.log(err);
        }
    },

    async fetchRates(userid) {
        try {
        const res = await this.$http.get(`/list-escort-rates/${userid}`);
        if (res.data.success && res.data.data.length > 0) {
            this.rates = res.data.data;
        } else {
           // this.rates = [{ duration: '', inCall: '', outCall: '' }];
        }
        } catch (err) {
        console.error('Failed to fetch rates', err);
        }
    },

    async handleLike(image) {
    try {
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to like this picture.',
            width: 400
          });
          return;
        }


      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/like-escort', {
          escort_id: this.escort_data.escortid,
          liked_by: this.user_id,
          image: image
        });

        if (response.data.success) {
          this.getUserEscortLikes(this.userid)

          if (this.escort_data.galleries && Object.keys(this.escort_data.galleries).length > 0) {
            Object.values(this.escort_data.galleries).forEach(image => {
              this.fetchLikeCount(image);
            });
          }

        } else {
          swal.fire({
            icon: 'warning',
            text: response.data.message || 'Unable to like picture.',
            width: 400
          });
        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleUnLike(image) {
    try {
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to like this picture.',
            width: 400
          });
          return;
        }


      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/unlike-escort', {
          escort_id: this.escort_data.escortid,
          liked_by: this.user_id,
          image: image
        });

        if (response.data.success) {

          this.getLikes(this.userid)

          if (this.escort_data.galleries && Object.keys(this.escort_data.galleries).length > 0) {
            Object.values(this.escort_data.galleries).forEach(image => {
              this.fetchLikeCount(image);
            });
          }

        } else {
          swal.fire({
            icon: 'warning',
            text: response.data.message || 'Unable to like picture.',
            width: 400
          });
        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleVideoLike(video) {
    try {
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to like this video.',
            width: 400
          });
          return;
        }


      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/like-escort', {
          escort_id: this.escort_data.escortid,
          liked_by: this.user_id,
          image: video
        });

        if (response.data.success) {

          this.getUserEscortLikes(this.userid)

        } else {
          swal.fire({
            icon: 'warning',
            text: response.data.message || 'Unable to like video.',
            width: 400
          });
        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleVideoUnLike(video) {
    try {
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to like this video.',
            width: 400
          });
          return;
        }


      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/unlike-escort', {
          escort_id: this.escort_data.escortid,
          liked_by: this.user_id,
          image: video
        });

        if (response.data.success) {

          this.getLikes(this.userid)

        } else {
          swal.fire({
            icon: 'warning',
            text: response.data.message || 'Unable to like video.',
            width: 400
          });
        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async getLikes(userid) {
    try {

        const response = await this.$http.get(`/escort-likes/${userid}`, {});
        this.countLikes = response.data.data.length
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async getUserEscortLikes(userid) {
    try {
        const response = await this.$http.get(`/user-escort-likes/${userid}`, {});
        this.image_likes = response.data.data;
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleFollow() {
    try {
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to follow this escort.',
            width: 400
          });
          return;
        }

      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/follow-escort', {
          escort_id: this.escort_data.escortid,
          followed_by: this.user_id,
        });

        if (response.data.success) {
        //   swal.fire({
        //     icon: 'success',
        //     text:  response.data.message,
        //     width: 400
        //   });

          this.getFollowers(this.userid)

        } else {
          swal.fire({
            icon: 'warning',
            text: response.data.message || 'Unable to follow escort.',
            width: 400
          });
        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleUnFollow() {
    try {
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to unfollow this escort.',
            width: 400
          });
          return;
        }

      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/unfollow-escort', {
          escort_id: this.escort_data.escortid,
          followed_by: this.user_id,
        });

        if (response.data.success) {

          this.getFollowers(this.userid)

        } else {
          swal.fire({
            icon: 'warning',
            text: response.data.message || 'Unable to follow escort.',
            width: 400
          });
        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async getFollowers(userid) {
    try {

        const response = await this.$http.get(`/escort-followers/${userid}`, {});
        this.countFollowers = response.data.data.length
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleChat() { 
        if (!this.user_id) {
            swal.fire({
            icon: 'warning',
            text: 'Please login to chat this escort.',
            width: 400
          });
          return;
        }
        this.$router.push(`/chat/${this.escort_data.user_id}/${this.escort_data.user_name}`)
    },

    async handleComment(image) {
    try {
      image
      //
      
    } catch (err) {
     //
    }
    },
    
  }
}

</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');

.rate-display-section {
  padding: 20px;
  background: #fefefe;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.rate-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 15px;
}

.image-wrapper{
  position: relative; 
  border-radius: 10px; 
  overflow: hidden;
}
.rate-card {
  background-color: #fff;
  border: 1px solid #D33E74;
  padding: 15px;
  border-radius: 10px;
  text-align: left;
  transition: 0.3s ease;
}

.rate-card:hover {
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.rate-duration {
  font-size: 22px;
  font-weight: 600;
  color: #D33E74;;
  margin-bottom: 8px;
}

.rate-price {
  font-size: 20px;
  color: #666;
  margin-bottom: 4px;
}

.no-rates {
  text-align: center;
  color: #999;
}

.preferences-list {
  width: 100%;
  padding: 20px;
  background: #fafafa;
  border-radius: 12px;
  font-family: 'Raleway';
  font-style: normal;
}

.preference-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  strong{
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background: #0A070F;
    padding: 0.3rem;
    border-radius: 5px;
  }
  span{
    color: #D33E74;
    font-size: 15px;
    font-weight: bold;
  }
}

.preference-item-p {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: #D33E74;
    font-size: 15px;
    font-weight: bold;
 

  strong{
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background: #0A070F;
    padding: 0.3rem;
    border-radius: 5px;
  }
  span{
    color: #D33E74;
    font-size: 15px;
    font-weight: bold;
  }
}

h2 {
  text-align: left;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 700;
}

.loading {
  text-align: center;
  font-weight: bold;
}

.no-data {
  text-align: center;
  color: #888;
}

.disabled-chat {
  pointer-events: none;
  background-color: #ccc;
  color: #888;
  border-radius: 5px;
  padding: 8px 12px;
  display: inline-block;
}


.nav-link{
    color: #D33E74;
}
 .nav-tabs .nav-link {
    cursor: pointer;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
 }

.nav-tabs .nav-link.active {
    background-color: #D33E74;
    color: white;
    border-radius: 0.25rem;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
}
.back a{
    text-decoration: none;
    color: #D33E74;
}
.mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .img-fluid{
    border-radius: 10px;
  }
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
  .verified-icon {
        margin-left: 5px;
        font-size: 16px;
        vertical-align: middle;
    }
    .text-success{
        color: #25D366 !important;
    }
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }
   }
.container {
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;


    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
         padding: 0 0 0 20px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 25px;
            line-height: 20px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            line-height: 20px;
            text-align: left;
            color: #FFFFFF;
        }        
        .likes-followers{

            h4{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 450;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center !important;
            }
        }
    }
    .select-profile{
        text-align: center !important;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;


    .btn-follow {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 100px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }

    .btn-like{
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 100px;
        height: 40px;
        background: #25D366;
        border: 0px solid #25D366;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
    .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 100px;
        height: 40px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
  //padding: 0rem 1rem 2rem 0rem;
  margin-left: 20px;
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #767475 !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    //color: #767475;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    //margin: 2px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {

   .gallery-header{
      padding: 10px 0 0 25px;
    }

    .col-sm-12{
      padding: 0 0px 0 0px !important;
    }
    .container{
        padding: 0px 0px 0px 0px !important;
    }
    .back{
        margin-top: 45px;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .bio-tab{
        margin-top: 20px;
    }
    .nav-link{
        color: #D33E74;
    }
    
    .nav-tabs .nav-link {
    cursor: pointer;
    }

    .nav-tabs .nav-link.active {
        background-color: #D33E74;
        color: white;
        border-radius: 0.25rem;
    }

    .mobile-line{
        display: flex;
        color: #767475;
        width: 100%;
    }
    .profile-image {
        display: flex;
        flex-direction: column;

        .img-profile {
            width: 30%;
            height: 30%;
        }
        .profile-info {
            padding: 10px 0 0 0px;
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 15px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            .likes-followers{
                margin-top: 10px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
        }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: right;
        align-items: center;
       margin-top: 20px;
    
        .btn-follow {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 8px;
            width: 80px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }

        .btn-like{
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 80px;
        height: 35px;
        background: #25D366;
        border: 0px solid #25D366;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }

        .btn-chat {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 8px;
            width: 80px;
            height: 35px;
            background: #007BFF;
            border: 0px solid;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
 .edit-profile-top {
  padding: 0rem 1rem 2rem 0rem;
  margin-left: 20px;
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    margin-left: 10px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        margin-left: 30%;
    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    //margin: 2px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>